// 初始化表情映射（大表情+默认小表情）。
export const initBigFace = () => {
  if (window.gbFaceConfigObj) return 
  window.gbFaceConfigObj = {
    "666": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot87.png",
      "size": 20
    },
    "微笑": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot1.png",
      "size": 20
    },
    "大笑": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot2.png",
      "size": 20
    },
    "鼓掌": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot3.png",
      "size": 20
    },
    "为什么": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot4.png",
      "size": 20
    },
    "哭": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot5.png",
      "size": 20
    },
    "怒": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot6.png",
      "size": 20
    },
    "滴汗": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot7.png",
      "size": 20
    },
    "俏皮": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot8.png",
      "size": 20
    },
    "傲": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot9.png",
      "size": 20
    },
    "好困惑": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot10.png",
      "size": 20
    },
    "兴奋": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot11.png",
      "size": 20
    },
    "加油": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot12.png",
      "size": 20
    },
    "困顿": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot13.png",
      "size": 20
    },
    "想一下": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot14.png",
      "size": 20
    },
    "撇嘴": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot15.png",
      "size": 20
    },
    "色": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot16.png",
      "size": 20
    },
    "发呆": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot17.png",
      "size": 20
    },
    "得意": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot18.png",
      "size": 20
    },
    "害羞羞": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot19.png",
      "size": 20
    },
    "大哭": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot20.png",
      "size": 20
    },
    "呲牙": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot21.png",
      "size": 20
    },
    "惊讶": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot22.png",
      "size": 20
    },
    "囧": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot23.png",
      "size": 20
    },
    "抓狂": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot24.png",
      "size": 20
    },
    "偷笑": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot25.png",
      "size": 20
    },
    "愉快": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot26.png",
      "size": 20
    },
    "憨笑": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot27.png",
      "size": 20
    },
    "晕": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot28.png",
      "size": 20
    },
    "再见": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot29.png",
      "size": 20
    },
    "坏笑": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot30.png",
      "size": 20
    },
    "左哼哼": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot31.png",
      "size": 20
    },
    "右哼哼": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot32.png",
      "size": 20
    },
    "哈欠": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot33.png",
      "size": 20
    },
    "委屈": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot34.png",
      "size": 20
    },
    "快哭了": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot35.png",
      "size": 20
    },
    "亲": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot36.png",
      "size": 20
    },
    "可怜": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot37.png",
      "size": 20
    },
    "口罩": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot38.png",
      "size": 20
    },
    "笑哭": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot39.png",
      "size": 20
    },
    "惊吓": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot40.png",
      "size": 20
    },
    "哼": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot41.png",
      "size": 20
    },
    "捂脸": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot42.png",
      "size": 20
    },
    "奸笑": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot43.png",
      "size": 20
    },
    "吃瓜": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot44.png",
      "size": 20
    },
    "旺柴": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot45.png",
      "size": 20
    },
    "围观": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot46.png",
      "size": 20
    },
    "摊手": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot47.png",
      "size": 20
    },
    "爱心": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot48.png",
      "size": 20
    },
    "献花": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot49.png",
      "size": 20
    },
    "福": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot50.png",
      "size": 20
    },
    "拜神": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot51.png",
      "size": 20
    },
    "胜利": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot52.png",
      "size": 20
    },
    "赞": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot53.png",
      "size": 20
    },
    "握手": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot54.png",
      "size": 20
    },
    "抱拳": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot55.png",
      "size": 20
    },
    "勾引": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot56.png",
      "size": 20
    },
    "拳头": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot57.png",
      "size": 20
    },
    "OKOK": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot58.png",
      "size": 20
    },
    "强壮": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot59.png",
      "size": 20
    },
    "毛估估": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot60.png",
      "size": 20
    },
    "亏大了": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot61.png",
      "size": 20
    },
    "赚大了": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot62.png",
      "size": 20
    },
    "牛": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot63.png",
      "size": 20
    },
    " ": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot64.png",
      "size": 20
    },
    "成交": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot65.png",
      "size": 20
    },
    "财力": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot66.png",
      "size": 20
    },
    "护城河": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot67.png",
      "size": 20
    },
    "复盘": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot68.png",
      "size": 20
    },
    "买入": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot69.png",
      "size": 20
    },
    "卖出": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot70.png",
      "size": 20
    },
    "满仓": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot71.png",
      "size": 20
    },
    "空仓": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot72.png",
      "size": 20
    },
    "抄底": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot73.png",
      "size": 20
    },
    "看多": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot74.png",
      "size": 20
    },
    "看空": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot75.png",
      "size": 20
    },
    "加仓": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot76.png",
      "size": 20
    },
    "减仓": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot77.png",
      "size": 20
    },
    "上涨": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot78.png",
      "size": 20
    },
    "下跌": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot79.png",
      "size": 20
    },
    "财神": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot80.png",
      "size": 20
    },
    "火箭": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot81.png",
      "size": 20
    },
    "龙头": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot82.png",
      "size": 20
    },
    "韭菜": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot83.png",
      "size": 20
    },
    "面": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot84.png",
      "size": 20
    },
    "泡沫": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot85.png",
      "size": 20
    },
    "惨!关灯吃面": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot86.png",
      "size": 20
    },
    "叹气": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot88.png",
      "size": 20
    },
    "让我看看": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot89.png",
      "size": 20
    },
    "发财": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot90.png",
      "size": 20
    },
    "主力": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot91.png",
      "size": 20
    },
    "梭哈": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot92.png",
      "size": 20
    },
    "国家队": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot93.png",
      "size": 20
    },
    "中签": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot94.png",
      "size": 20
    },
    "干杯": {
      "src": "http://gbfek.dfcfw.com/face/emot_default/emot95.png",
      "size": 20
    },
    "OK": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn1/01.png",
      "size": 30
    },
    "中新股": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn1/02.png",
      "size": 30
    },
    "跌停板": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn1/03.png",
      "size": 30
    },
    "赚了一点": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn1/04.png",
      "size": 30
    },
    "求中签": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn1/05.png",
      "size": 30
    },
    "开盘": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn1/06.png",
      "size": 30
    },
    "套牢": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn1/07.png",
      "size": 30
    },
    "没钱补仓": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn1/08.png",
      "size": 30
    },
    "亏损": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn1/09.png",
      "size": 30
    },
    "哈哈": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn1/10.png",
      "size": 30
    },
    "认同": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn1/11.png",
      "size": 30
    },
    "涨停板": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn1/12.png",
      "size": 30
    },
    "快割肉": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn1/13.png",
      "size": 30
    },
    "亏空": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn1/14.png",
      "size": 30
    },
    "赚钱": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn1/15.png",
      "size": 30
    },
    "凄凉": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn1/16.png",
      "size": 30
    },
    "一把梭": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn2/02.png",
      "size": 30
    },
    "敢死队": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn2/03.png",
      "size": 30
    },
    "跳水": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn2/04.png",
      "size": 30
    },
    "割韭菜": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn2/05.png",
      "size": 30
    },
    "牛气冲天": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn2/06.png",
      "size": 30
    },
    "全是泡沫": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn2/07.png",
      "size": 30
    },
    "庄家入场": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn2/08.png",
      "size": 30
    },
    "庄家护盘": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn2/09.png",
      "size": 30
    },
    "满仓踏空": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn2/11.png",
      "size": 30
    },
    "膜拜大神": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn2/12.png",
      "size": 30
    },
    "龙头股": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn2/13.png",
      "size": 30
    },
    "毛估估一下": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn2/14.png",
      "size": 30
    },
    "佛系炒股": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn2/15.png",
      "size": 30
    },
    "重磅消息": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn2/16.png",
      "size": 30
    },
    "准备发射": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn2/17.png",
      "size": 30
    },
    "关灯吃面": {
      "src": "https://gbfek.dfcfw.com/face_bundle/dcxn2/18.png",
      "size": 30
    },
    "开盘啦": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cjxn/0001.png",
      "size": 30
    },
    "涨疯了": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cjxn/0002.png",
      "size": 30
    },
    "哟吼": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cjxn/0003.png",
      "size": 30
    },
    "发财啦": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cjxn/0004.png",
      "size": 30
    },
    "买买买": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cjxn/0005.png",
      "size": 30
    },
    "求个牛股": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cjxn/0006.png",
      "size": 30
    },
    "思考": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cjxn/0007.png",
      "size": 30
    },
    "宝宝委屈": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cjxn/0008.png",
      "size": 30
    },
    "生气": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cjxn/0009.png",
      "size": 30
    },
    "接盘侠": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cjxn/0010.png",
      "size": 30
    },
    "NO": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cjxn/0011.png",
      "size": 30
    },
    "被掏空": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cjxn/0012.png",
      "size": 30
    },
    "被套牢": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cjxn/0013.png",
      "size": 30
    },
    "求内幕": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cjxn/0014.png",
      "size": 30
    },
    "是底部": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cjxn/0015.png",
      "size": 30
    },
    "散户必胜": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cjxn/0016.png",
      "size": 30
    },
    "有钱啦": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cdd/00.png",
      "size": 30
    },
    "耶": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cdd/01.png",
      "size": 30
    },
    "愤怒": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cdd/02.png",
      "size": 30
    },
    "厉害": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cdd/03.png",
      "size": 30
    },
    "疑惑": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cdd/04.png",
      "size": 30
    },
    "嗯哼": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cdd/05.png",
      "size": 30
    },
    "亲亲": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cdd/06.png",
      "size": 30
    },
    "懵": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cdd/07.png",
      "size": 30
    },
    "嘻嘻": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cdd/08.png",
      "size": 30
    },
    "吐血": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cdd/09.png",
      "size": 30
    },
    "泪": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cdd/10.png",
      "size": 30
    },
    "害羞": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cdd/11.png",
      "size": 30
    },
    "鬼脸": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cdd/12.png",
      "size": 30
    },
    "震惊": {
      "src": "https://gbfek.dfcfw.com/face_bundle/cdd/13.png",
      "size": 30
    },
    "想想": {
      "src": "https://gbfek.dfcfw.com/face_bundle/mxjqrjt/1_想想.png",
      "size": 30
    },
    "hello": {
      "src": "https://gbfek.dfcfw.com/face_bundle/mxjqrjt/2_hello.png",
      "size": 30
    },
    "ok!": {
      "src": "https://gbfek.dfcfw.com/face_bundle/mxjqrjt/3_ok!.png",
      "size": 30
    },
    "比心": {
      "src": "https://gbfek.dfcfw.com/face_bundle/mxjqrjt/4_比心.png",
      "size": 30
    },
    "点赞": {
      "src": "https://gbfek.dfcfw.com/face_bundle/mxjqrjt/5_点赞.png",
      "size": 30
    },
    "感谢": {
      "src": "https://gbfek.dfcfw.com/face_bundle/mxjqrjt/6_感谢.png",
      "size": 30
    },
    "干杯!": {
      "src": "https://gbfek.dfcfw.com/face_bundle/mxjqrjt/7_干杯!.png",
      "size": 30
    },
    "加油!": {
      "src": "https://gbfek.dfcfw.com/face_bundle/mxjqrjt/8_加油!.png",
      "size": 30
    },
    "开心": {
      "src": "https://gbfek.dfcfw.com/face_bundle/mxjqrjt/9_开心.png",
      "size": 30
    },
    "伤心": {
      "src": "https://gbfek.dfcfw.com/face_bundle/mxjqrjt/10_伤心.png",
      "size": 30
    },
    "小红花": {
      "src": "https://gbfek.dfcfw.com/face_bundle/mxjqrjt/11_小红花.png",
      "size": 30
    },
    "疑问": {
      "src": "https://gbfek.dfcfw.com/face_bundle/mxjqrjt/12_疑问.png",
      "size": 30
    }
  }
}

// 文本中 [表情] 替换为 <img>
export const replaceEmoji = (text) => {
  if (!text) return ''
  const map = window.gbFaceConfigObj || {}
  return text.replace(/\[(.+?)\]/g, (all, name) => {
    const conf = map[name]
    if (!conf) return all
    const size = conf.size || 20
    return `<img class="emot" title="${name}" alt="${name}" src="${conf.src}" style="width:${size}px;height:${size}px;vertical-align:middle;" />`
  })
}

// 便捷方法：若未初始化先初始化再替换
export const parseEmoji = (text) => {
  if (!window.gbFaceConfigObj) initBigFace()
  return replaceEmoji(text)
}